import { Button, DialogOverlay, DialogOverlayActions, DialogOverlayFooter } from '@fs/zion-ui'
import { FlowGrid } from '@fs/zion-ui/dist/cjs/flow-grid'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const LimitedAccessImageDialog = ({ permissions, overlay }) => {
  const [t] = useTranslation()

  const PERMISSION_MAP = useMemo(
    () => ({
      ThemisPrmAffiliate: t('limitedAccessImageDialog.permissions.themisPrmAffiliate', 'At an Affiliate Library'),
      ThemisPrmFhlc: t('limitedAccessImageDialog.permissions.themisPrmFhlc', 'At a FamilySearch Center'),
      ThemisPrmFhlSLC: t(
        'limitedAccessImageDialog.permissions.themisPrmFhlSLC',
        'At the Salt Lake City Family History Library'
      ),
      ThemisPrmLdsMember: t(
        'limitedAccessImageDialog.permissions.themisPrmLdsMember',
        'A member of a supporting organization'
      ),
    }),
    [t]
  )

  const permissionsList = permissions
    ?.split(':')
    ?.map((perm) => PERMISSION_MAP[perm])
    ?.filter(Boolean)

  return (
    <DialogOverlay title={t('limitedAccessImageDialog.title', 'Limited access images')} {...overlay}>
      <FlowGrid columns={1} orientation="vertical" gap="large" gutters="xs">
        <>
          {t(
            'limitedAccessImageDialog.description',
            'Access to these images is limited due to agreements with the record owners or legal restrictions based on location or organization membership. You can view them if you are:'
          )}
        </>

        <ul>
          {permissionsList?.map((permission) => (
            <li data-key={permission} key={permission}>
              {permission}
            </li>
          ))}
        </ul>

        <>
          {t(
            'limitedAccessImageDialog.footer',
            'If you share a link with someone that doesn’t meet these conditions, they won’t have access.'
          )}
        </>
      </FlowGrid>
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button emphasis="high" onClick={overlay.handleClick}>
            {t('limitedAccessImageDialog.done', 'Done')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}

export default LimitedAccessImageDialog
